import React, { useEffect, useState, useRef } from "react";
import CalendarViews from "./calendar_views.js";
import LoadingPopup from "../helpers/loading_component.js";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/login.css";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const Login = (props) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [usersData, setUsersData] = useState([]);
  const [version, setVersion] = useState("");

  const handleLoginChange = (e) => {
    setLogin(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLogin = (e) => {
    var check = usersData.filter(
      (el) => el.login === login && el.password === password
    );
    if (check.length > 0) {
      props.handleUserLogin(check[0]);
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Nieprawidłowe dane logowania",
      });
    }
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersData(data);
        fetchVersion();
      })
      .catch((error) => {});
  };

  const fetchVersion = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getVersion", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var v = data[0].name;
        setVersion(v);
        if (v === "35") {
          setLoading(false);
        } else {
          MySwal.fire({
            icon: "error",
            title: "Nieprawidłowa wersja aplikacji!",
            text: "Odśwież stronę, aby wczytać najnowszą wersję: użyj dedykowanej funkcji przeglądarki, wciśnij klawisz F5 (dla laptopów Fn+F5). Rozważ wyczyszczenie cookies.",
          }).then((result) => {
            window.location.reload(false);
          });
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    setLoading(true);
    fetchUsers();
  }, []);

  return (
    <>
      {loading ? (
        <LoadingPopup login={props.login} />
      ) : (
        <div className="mainContainerLoginPage">
          <div className="logoBoxLogin">
            <img
              className="imgLogo"
              src="https://ftpeople.pl/wp-content/uploads/2023/06/logomain.png"
              alt=""
            />
          </div>
          <div className="inputContainerLogin">
            <div className="inputBoxLogin">
              <label id="loginLabel">Login</label>
              <input
                type="text"
                id="login"
                name="login"
                value={login}
                onChange={handleLoginChange}
              />
              <label id="loginLabel">Hasło</label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={handlePasswordChange}
              />
              <button
                className="loginButtonLogin"
                value="yes"
                onClick={handleLogin}
              >
                ZALOGUJ
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
